import { useEffect, useRef, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Slider } from "@/components/ui/slider";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Volume1, Volume2, VolumeX } from "lucide-react";

export const MediaVolume = ({ initial }) => {
  const [vol, setVol] = useState(initial ?? 80);
  const timer = useRef(null);
  useEffect(() => { setVol(initial ?? 80); }, [initial]);
  useEffect(() => () => clearTimeout(timer.current), []);
  const change = (v) => {
    setVol(v);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      api.put("/tv/media-volume", { volume: v }).catch((err) => toast.error(formatApiErrorDetail(err.response?.data?.detail)));
    }, 350);
  };
  const Icon = vol === 0 ? VolumeX : vol < 50 ? Volume1 : Volume2;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" data-testid="media-volume-button" title="Volume dos vídeos na TV"
          className="rounded-md gap-2 border-border text-ink hover:bg-accent">
          <Icon className="w-4 h-4" /> <span className="hidden sm:inline tabular-nums">{vol}%</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 rounded-md" data-testid="media-volume-popover">
        <p className="font-heading font-semibold text-ink text-sm">Volume dos vídeos na TV</p>
        <p className="text-xs text-cappuccino mb-4">Muda na TV em poucos segundos. Durante a chamada o vídeo abaixa sozinho.</p>
        <div className="flex items-center gap-3">
          <button type="button" onClick={() => change(0)} data-testid="media-volume-mute" className="text-cappuccino hover:text-ink">
            <VolumeX className="w-4 h-4" />
          </button>
          <Slider value={[vol]} min={0} max={100} step={5} onValueChange={([v]) => change(v)} data-testid="media-volume-slider" className="flex-1" />
          <span className="text-sm font-semibold text-ink w-10 text-right tabular-nums" data-testid="media-volume-value">{vol}%</span>
        </div>
      </PopoverContent>
    </Popover>
  );
};
